export default "__VITE_ASSET__B$sCFRVz__"